<template>
  <div
    :style="{
      'background-image': 'url(' + setBgImage + ')'
    }"
    :class="{ 'hero-caroucel-item--dimmed': !dimmed }"
    class="hero-caroucel-item"
  >
    <div class="hero-caroucel-item__container">
      <div class="hero-caroucel-item__contents">
        <div :style="{ color: textColor }" class="hero-caroucel-item__subtitle">
          <slot name="subtitle"></slot>
        </div>
        <div :style="{ color: textColor }" class="hero-caroucel-item__title">
          <slot name="title"></slot>
        </div>
        <div class="hero-caroucel-item__btn">
          <slot name="button"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bgImage: {
      type: String,
      required: true
    },
    bgMobileImage: {
      type: String,
      default: null
    },
    dimmed: {
      type: Boolean,
      default: true
    },
    textColor: {
      type: String,
      default: '#ffffff'
    }
  },
  computed: {
    setBgImage() {
      if (!this.bgMobileImage) return this.bgImage
      return this.isMobile ? this.bgMobileImage : this.bgImage
    },
    isMobile() {
      const mq = this.$mq
      return mq === 'thumb' || mq === 'pocket'
    }
  }
}
</script>

<style lang="scss" scoped>
.hero-caroucel-item {
  position: relative;
  height: 460px;
  min-height: 460px;
  background: #000;
  background-size: cover;
  background-position: 70% center;
  background-repeat: no-repeat;

  @include av-mq(lap-and-up) {
    height: 708px;
    min-height: 708px;
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0.4;
    mix-blend-mode: multiply;
    background-color: #000;
    z-index: 1;
  }

  &--dimmed {
    &:after {
      opacity: 0.1;
    }

    .hero-caroucel-item__title,
    .hero-caroucel-item__subtitle {
      text-shadow: none;
    }
  }

  &__container {
    position: relative;
    max-width: 1024px;
    margin: 0 auto;
    height: 100%;
  }

  &__contents {
    position: absolute;
    left: 1rem;
    top: 200px;
    z-index: 2;

    @include av-mq(lap-and-up) {
      top: 280px;
    }
  }

  &__title {
    margin-bottom: 1rem;
    font-size: 26px;
    line-height: 1.3;
    text-shadow: 0px 0px 20px #333;
    font-weight: 500;

    @include av-mq(lap-and-up) {
      margin-bottom: 2rem;
      font-size: 48px;
    }
  }

  &__subtitle {
    margin-bottom: 0.5rem;
    font-size: 16px;
    z-index: 2;
    text-shadow: 0px 0px 20px #333;

    @include av-mq(lap-and-up) {
      margin-bottom: 1rem;
      font-size: 24px;
    }
  }
}
</style>
